import React from "react";
import "./Board.css";
import RiddleCard from "../RiddleCard/RiddleCard";
import MultiLineConnector from "../MultiLineConnector/MultiLineConnector";

const Board = ({ overWriteFunction, solvedArray = new Array(20).fill(false), rfidEnabled = new Array(20).fill(false), rfidDisabled = new Array(20).fill(false), solvedRiddles }) => {
    let dots
    if (rfidEnabled == null) {
        dots = [
            { x: -10, y: 10, hidden:true }, //0
            { x: 25, y: 25, t:1, enabled:false }, //1
            { x: 50, y: 5, t:1, enabled:false }, //2
            { x: 60, y: 22, t:1, enabled:false }, //3
            { x: 97, y: 12, t:1, enabled:false }, //4

            //string 2
            { x: -10, y: 30, hidden:true }, //5
            { x: 5, y: 25, t:2, enabled:false }, //6
            { x: 32, y: 35, t:2, enabled:false }, //7
            { x: 75, y: 23, t:2, enabled: false }, //8
            { x: 97, y: 30, t:2, enabled:false }, //9

            // //string 3
            { x: -10, y: 40, hidden:true }, //10
            { x: 30, y: 75, t:3, enabled:false }, //11
            { x: 52, y: 38, t:3, enabled:false }, //12
            { x: 65, y: 48, t:3, enabled:false }, //13
            { x: 97, y: 46, t:3, enabled:false }, //14

            // //string 4
            { x: -10, y: 70, hidden: true }, //15
            { x: 25, y: 48, t:4, enabled:false }, //16
            { x: 44, y: 75, t:4, enabled:false }, //17
            { x: 70, y: 56, t:4, enabled:false }, //18
            { x: 97, y: 60, t:4, enabled:false }, //19

            // //string 5
            { x: -10, y: 90, hidden: true }, //20
            { x: 22, y: 75, t:5, enabled:false }, //21
            { x: 44, y: 95, t:5, enabled:false }, //22
            { x: 50, y: 80, t:5, enabled:false }, //23
            { x: 97, y: 80, t:5, enabled:false }, //24
        ];
    } else {
        dots = [
            //string 1
            { x: -10, y: 10, hidden:true }, //0
            { x: 25, y: 25, t:1, enabled:rfidEnabled[0] ?? false, disabled:rfidDisabled[0] ?? false }, //1
            { x: 50, y: 5, t:1, enabled:rfidEnabled[1] ?? false, disabled:rfidDisabled[1] ?? false  }, //2
            { x: 60, y: 22, t:1, enabled:rfidEnabled[2] ?? false, disabled:rfidDisabled[2] ?? false  }, //3
            { x: 97, y: 12, t:1, enabled:rfidEnabled[3] ?? false, disabled:rfidDisabled[3] ?? false  }, //4

            //string 2
            { x: -10, y: 30, hidden:true }, //5
            { x: 5, y: 25, t:2, enabled:rfidEnabled[4] ?? false, disabled:rfidDisabled[4] ?? false  }, //6
            { x: 32, y: 35, t:2, enabled:rfidEnabled[5] ?? false, disabled:rfidDisabled[5] ?? false  }, //7
            { x: 75, y: 23, t:2, enabled:rfidEnabled[6] ?? false, disabled:rfidDisabled[6] ?? false  }, //8
            { x: 97, y: 30, t:2, enabled:rfidEnabled[7] ?? false, disabled:rfidDisabled[7] ?? false  }, //9

            // //string 3
            { x: -10, y: 40, hidden:true }, //10
            { x: 30, y: 75, t:3, enabled:rfidEnabled[8] ?? false, disabled:rfidDisabled[8] ?? false  }, //11
            { x: 52, y: 38, t:3, enabled:rfidEnabled[9] ?? false, disabled:rfidDisabled[9] ?? false  }, //12
            { x: 65, y: 48, t:3, enabled:rfidEnabled[10] ?? false, disabled:rfidDisabled[10] ?? false  }, //13
            { x: 97, y: 46, t:3, enabled:rfidEnabled[11] ?? false, disabled:rfidDisabled[11] ?? false  }, //14

            // //string 4
            { x: -10, y: 70, hidden: true }, //15
            { x: 25, y: 48, t:4, enabled:rfidEnabled[12] ?? false, disabled:rfidDisabled[12] ?? false  }, //16
            { x: 44, y: 75, t:4, enabled:rfidEnabled[13] ?? false, disabled:rfidDisabled[13] ?? false  }, //17
            { x: 70, y: 56, t:4, enabled:rfidEnabled[14] ?? false, disabled:rfidDisabled[14] ?? false  }, //18
            { x: 97, y: 60, t:4, enabled:rfidEnabled[15] ?? false, disabled:rfidDisabled[15] ?? false  }, //19

            // //string 5
            { x: -10, y: 90, hidden: true }, //20
            { x: 22, y: 75, t:5, enabled:rfidEnabled[16] ?? false, disabled:rfidDisabled[16] ?? false  }, //21
            { x: 44, y: 95, t:5, enabled:rfidEnabled[17] ?? false, disabled:rfidDisabled[17] ?? false  }, //22
            { x: 50, y: 80, t:5, enabled:rfidEnabled[18] ?? false, disabled:rfidDisabled[18] ?? false  }, //23
            { x: 97, y: 80, t:5, enabled:rfidEnabled[19] ?? false, disabled:rfidDisabled[19] ?? false  }, //24

        ];
    }


    // Define which dots to connect (by index)
    const connections = [
        //string 1
        { start: 0, end: 1, solved:solvedArray[0], active:solvedRiddles[0] ?? false },
        { start: 1, end: 2, solved:solvedArray[1], active:solvedRiddles[0] ?? false },
        { start: 2, end: 3, solved:solvedArray[2], active:solvedRiddles[0] ?? false },
        { start: 3, end: 4, solved:solvedArray[3], active:solvedRiddles[0] ?? false },

        //string 2
        { start: 5, end: 6, solved:solvedArray[4], active:solvedRiddles[1] ?? false },
        { start: 6, end: 7, solved:solvedArray[5], active:solvedRiddles[1] ?? false },
        { start: 7, end: 8, solved:solvedArray[6], active:solvedRiddles[1] ?? false },
        { start: 8, end: 9, solved:solvedArray[7], active:solvedRiddles[1] ?? false },

        //string 3
        { start: 10, end: 11, solved:solvedArray[8], active:solvedRiddles[2] ?? false },
        { start: 11, end: 12, solved:solvedArray[9], active:solvedRiddles[2] ?? false },
        { start: 12, end: 13, solved:solvedArray[10], active:solvedRiddles[2] ?? false },
        { start: 13, end: 14, solved:solvedArray[11], active:solvedRiddles[2] ?? false },

        //string 4
        { start: 15, end: 16, solved:solvedArray[12], active:solvedRiddles[3] ?? false },
        { start: 16, end: 17, solved:solvedArray[13], active:solvedRiddles[3] ?? false },
        { start: 17, end: 18, solved:solvedArray[14], active:solvedRiddles[3] ?? false },
        { start: 18, end: 19, solved:solvedArray[15], active:solvedRiddles[3] ?? false },

        //string 5
        { start: 20, end: 21, solved:solvedArray[16], active:solvedRiddles[4] ?? false },
        { start: 21, end: 22, solved:solvedArray[17], active:solvedRiddles[4] ?? false },
        { start: 22, end: 23, solved:solvedArray[18], active:solvedRiddles[4] ?? false },
        { start: 23, end: 24, solved:solvedArray[19], active:solvedRiddles[4] ?? false },

    ];

    const mainDiv = (
        <>
            <div className="container">
                <MultiLineConnector dots={dots} connections={connections} overWriteFunction={overWriteFunction}/>
            </div>
        </>
    );
    return (
        <RiddleCard title={"Investigation Board"} layout={"full-size"} mainInfo={mainDiv}
                    displayFlexColumn={true} center={true} connected={rfidEnabled != null}></RiddleCard>
    )
}

export default Board;